import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { transition, trigger, style, animate } from '@angular/animations';
import { ViewLayout } from '../../models/view-layout.enum';
import { ViewService } from '../../view.service';
import { LayoutService } from '../../layout.service';
import { Select } from '@ngxs/store';
import { ViewState } from '../../state/view.state';
import { Observable, Subject, combineLatest } from 'rxjs';
import { LayoutStateModel } from 'src/app/layout/state/layout.state.model';
import { takeUntil } from 'rxjs/operators';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { ChapterModel } from 'src/app/story/models/chapter.model';
import { ViewLayoutModel } from '../../models/view-layout.model';
import { ViewLayoutStatus } from '../../models/view-layout-status.enum';

@Component({
  selector: 'app-view-column-toggle',
  templateUrl: './view-column-toggle.component.html',
  styleUrls: ['./view-column-toggle.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('show', [
      transition(':enter', [
        style({ 
          opacity: 0,
          transform: 'translateX(-32px)'
        }),
        animate('300ms ease-in-out', style({ 
          opacity: 1,
          transform: '*'
        }))
      ]),
      transition(':leave', [
        animate('300ms ease-in-out', style({ 
          transform: 'translateX(-32px)',
          opacity: 0 
        }))
      ])
    ])
  ]
})
export class ViewColumnToggleComponent implements OnInit, OnDestroy {
  @Select(ViewState.getLayout)
  layout$: Observable<ViewLayoutModel>;

  @Select(StoryChaptersState.getSelectedChapter)
  chapter$: Observable<ChapterModel>;

  ngUnsubscribe = new Subject();
  isIn = false;

  constructor(
    private viewService: ViewService,
    private layoutService: LayoutService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    combineLatest(this.chapter$, this.layout$)
      .pipe(
        takeUntil(this.ngUnsubscribe)
      ).subscribe(([chapter, layout]) => {
        this.isIn = layout.column.status === ViewLayoutStatus.Collapse;
        
        this.changeDetectorRef.markForCheck();
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  isVisible() {
    return this.layoutService.isVisible(ViewLayout.ColumnToggle);
  }

  handleToggleClick() {
    this.viewService.toggleColumn();
    this.changeDetectorRef.markForCheck();
  }

}
